export default __webpack_public_path__ + "assets/images/4b0604ac0373c0bfae83e8238346e6f8.jpg";